import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'bmcore-volume-down-icon',
  templateUrl: './bmcore-volume-down-icon.component.html',
  styleUrls: ['./bmcore-volume-down-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreVolumeDownIconComponent {
  @Input() color = 'currentColor'
  @Input() width = 24
  @Input() height = 24
}
